module.exports = __webpack_public_path__ + "3f16e137/img/trash-icon.ff8201c7.svg";